export default {"src":"/_next/static/media/textura.53eccce4.svg","height":1295,"width":1921};